import { createGlobalStyle } from 'styled-components';
import RobotoBlack from '../fonts/Roboto-Black.ttf';
import RobotoBlackItalic from '../fonts/Roboto-BlackItalic.ttf';
import RobotoBold from '../fonts/Roboto-Bold.ttf';
import RobotoBoldItalic from '../fonts/Roboto-BoldItalic.ttf';
import RobotoItalic from '../fonts/Roboto-Italic.ttf';
import RobotoLight from '../fonts/Roboto-Light.ttf';
import RobotoLightItalic from '../fonts/Roboto-LightItalic.ttf';
import RobotoMedium from '../fonts/Roboto-Medium.ttf';
import RobotoMediumItalic from '../fonts/Roboto-MediumItalic.ttf';
import RobotoRegular from '../fonts/Roboto-Regular.ttf';
import RobotoThin from '../fonts/Roboto-Thin.ttf';
import RobotoThinItalic from '../fonts/Roboto-ThinItalic.ttf';
import { COLORS, MEDIA_BREAKPOINT } from './variables';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Black'),
    url(${RobotoBlack}) format('truetype'),
    url(${RobotoBlack}) format('opentype');
    font-weight: 900;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Black Italic'),
    url(${RobotoBlackItalic}) format('truetype'),
    url(${RobotoBlackItalic}) format('opentype');
    font-weight: 900;
    font-style: italic;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Bold'),
    url(${RobotoBold}) format('truetype'),
    url(${RobotoBold}) format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Bold Italic'),
    url(${RobotoBoldItalic}) format('truetype'),
    url(${RobotoBoldItalic}) format('opentype');
    font-weight: 700;
    font-style: italic;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Italic'),
    url(${RobotoItalic}) format('truetype'),
    url(${RobotoItalic}) format('opentype');
    font-weight: 400;
    font-style: italic;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Light'),
    url(${RobotoLight}) format('truetype'),
    url(${RobotoLight}) format('opentype');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Light Italic'),
    url(${RobotoLightItalic}) format('truetype'),
    url(${RobotoLightItalic}) format('opentype');
    font-weight: 300;
    font-style: italic;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Medium'),
    url(${RobotoMedium}) format('truetype'),
    url(${RobotoMedium}) format('opentype');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Medium Italic'),
    url(${RobotoMediumItalic}) format('truetype'),
    url(${RobotoMediumItalic}) format('opentype');
    font-weight: 500;
    font-style: italic;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Regular'),
    url(${RobotoRegular}) format('truetype'),
    url(${RobotoRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto Thin'),
    url(${RobotoThin}) format('truetype'),
    url(${RobotoThin}) format('opentype');
    font-weight: 100;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto ThinItalic'),
    url(${RobotoThinItalic}) format('truetype'),
    url(${RobotoThinItalic}) format('opentype');
    font-weight: 100;
    font-style: italic;
  }

  html {
    font-size: 50%;
    font-family: 'Roboto';
    touch-action: manipulation;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;

    @media ${MEDIA_BREAKPOINT.DESKTOP_L} {
      font-size: 62.5%;
    }
  }

  body {
    position: relative;
    min-height: 100%;
    background-color: ${COLORS.WHITE_1};
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0;
  }

  main {
    display: block;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    border-top-width: 1px;
  }

  pre,
  code,
  kbd,
  samp {
    font-size: 1em;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  }

  a {
    color: inherit;
    text-decoration: inherit;
    background-color: transparent;
  }

  abbr[title] {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline;
    text-decoration: underline dotted;
    border-bottom: none;
  }

  b,
  strong {
    font-weight: bold;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font-size: 100%;
    font-family: inherit;
    line-height: 1.15;
  }

  button,
  input {
    overflow: visible;
  }

  textarea:focus, input:focus {
    outline: none;
  }

  .default__control--is-focused,
  .rounded__control--is-focused,
  .label-price__control--is-focused {
    border-color: ${COLORS.BLACK} !important;
    box-shadow: 0 0 0 1px ${COLORS.BLACK} !important;

    &:hover {
      border-color: ${COLORS.BLACK} !important;
    }
  }

  button,
  select {
    text-transform: none;
  }

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    display: table;
    box-sizing: border-box;
    max-width: 100%;
    padding: 0;
    color: inherit;
    white-space: normal;
  }

  progress {
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  [type='search'] {
    outline-offset: -2px;
    -webkit-appearance: textfield;
  }

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none !important;
  }

  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }

  details {
    display: block;
  }

  summary {
    display: list-item;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none !important;
  }

  body,
  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: 0;
  }

  button {
    padding: 0;
    background: transparent;
  }

  fieldset {
    margin: 0;
    padding: 0;
  }

  ol,
  ul {
    margin: 0;
    padding: 0;
  }

  textarea {
    resize: vertical;
  }

  button,
  [role='button'] {
    cursor: pointer;
  }

  button::-moz-focus-inner {
    border: 0 !important;
  }

  table {
    border-collapse: collapse;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: inherit;
    font-size: inherit;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    padding: 0;
    color: inherit;
    line-height: inherit;
  }

  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
  }

  img,
  video {
    max-width: 100%;
    height: auto;
  }

  [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }

  select::-ms-expand {
    display: none;
  }

  .Toastify__toast-container--top-center {
    top: 10%;
    width: auto;
  }

  .pac-container {
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
    border: none;
    &:after {
      content: none;
    }
  }
  .not-scroll-body {
    height: 100%;
    overflow-y: hidden;
  }
`;
